import { useChatStore } from '@/stores/chat'
import { ref, Ref } from 'vue'
import Cookie from '@/services/cookie'

interface IframeControl {
  toggle:Ref<boolean>;
  updateCoreValuesOnStore(): void;
  notifyOpen(): void;
}

const toggle = ref<boolean>(false)

export default function iframeInternalChat (): IframeControl {
  const chatStore = useChatStore()

  function updateCoreValuesOnStore (): void {

    const token = Cookie.getToken('_chat_auth') as string

    if (token) {
      chatStore.upBearer(token)
      return
    }
    chatStore.upBearer(process.env.VUE_APP_INTERNAL_CHAT_TOKEN)
  }

  function notifyOpen (): void {
    toggle.value = true
    window.parent.postMessage({
      isWidget: true,
      isOpen: true
    }, '*')
  }

  return {
    toggle,
    updateCoreValuesOnStore,
    notifyOpen
  }
}
